import { render, staticRenderFns } from "./taxInvoice.vue?vue&type=template&id=7cda1186&scoped=true"
import script from "./taxInvoice.vue?vue&type=script&lang=js"
export * from "./taxInvoice.vue?vue&type=script&lang=js"
import style0 from "./taxInvoice.vue?vue&type=style&index=0&id=7cda1186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cda1186",
  null
  
)

export default component.exports